import React from "react";
import { Button } from "../../components/ui/button";
import { Link } from "react-router-dom";
import { FlaskConical } from "lucide-react";

const TrialistLandingPage = () => {
  return (
    <div className='min-h-screen bg-black text-white flex flex-col'>
      <main className='flex-1 flex flex-col justify-center items-center text-center p-8'>
        <div className='mb-8'>
          <FlaskConical className='w-16 h-16 text-green-500 animate-pulse' />
        </div>

        <h1 className='text-5xl font-bold mb-4 text-green-500'>Trialist</h1>

        <p className='text-xl mb-8 max-w-lg mx-auto text-gray-300'>
          Research Study App
        </p>

        <p className='text-lg mb-12 max-w-2xl mx-auto text-gray-400'>
          Participate in scientific research studies from the comfort of your phone.
          Contribute to groundbreaking discoveries while earning rewards for your time.
        </p>

        <div className='flex flex-col sm:flex-row gap-4 mb-12'>
          <Link to='/trialist/contact'>
            <Button className='bg-green-600 hover:bg-green-700 text-white px-8 py-3'>
              Get in Touch
            </Button>
          </Link>
        </div>

        <div className='flex gap-6 text-sm text-gray-500'>
          <Link to='/trialist/terms' className='hover:text-green-500 transition-colors'>
            Terms of Service
          </Link>
          <Link to='/trialist/privacy' className='hover:text-green-500 transition-colors'>
            Privacy Policy
          </Link>
        </div>
      </main>

      <footer className='py-6 text-center text-gray-600 text-xs'>
        <p>&copy; 2024 Anyone Labs</p>
        <div className='mt-2'>
          <Link to='/' className='hover:text-gray-400'>
            Anyone Labs Home
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default TrialistLandingPage;
